// extracted by mini-css-extract-plugin
export default {"faqSection":"faqs-module__faqSection___3MV_M","header":"faqs-module__header___3dS6E","faqContainer":"faqs-module__faqContainer___23x5a"};